module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("担心停止维护")]), _vm._v(" "), _c('p', [_vm._v("一个项目会停止维护主要原因是社区不活跃，用户量不够多，而且没有人愿意贡献。")]), _vm._v(" "), _c('p', [_vm._v("VUX 和 Vue 一样正在发展中，越多越多的开发者在使用，在可预见的时间内不会突然停止维护。")]), _vm._v(" "), _c('p', [_vm._v("希望大家能帮助完善文档，完善代码，帮助项目发展。")]), _vm._v(" "), _c('p', [_vm._v("能贡献代码的贡献代码，"), _c('del', [_vm._v("不能贡献代码直接用钱也可以 😃")]), _vm._v(" 。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f34ab8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-1f34ab8a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/will-vux-stop-maintaining-56.vue
// module id = 2080
// module chunks = 172